<div class="Miscellaneous" [class.fill]="isEmbed">
  <def-sprites sprite="404"></def-sprites>
  <h3 class="Miscellaneous-title">{{'MISCELLANEOUS.TITLE' | translate}}</h3>
  <p class="Miscellaneous-text">{{'MISCELLANEOUS.TEXT' | translate}}</p>
  <def-button *ngIf="!isEmbed" (click)="goHome()" color="primary">{{'MISCELLANEOUS.BUTTON' | translate}}</def-button>
</div>
<div *ngIf="!isEmbed" class="grey-footer"></div>
